import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginFormComponent } from './login-form/login-form.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { UiPartialModule } from '../ui-partial/ui-partial.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule, 
    ReactiveFormsModule,
    UiPartialModule,
  ],
  declarations: [
    LoginFormComponent
  ],
  exports: [
    LoginFormComponent
  ]
})
export class UiLoginModule { }
